import { __assign, __rest } from "tslib";
import React from 'react';
import { StepLabel as MaterialStepLabel, createStyles, makeStyles, } from '@material-ui/core';
import { StepIcon } from './StepIcon';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        label: (_a = {
                display: 'none'
            },
            _a[theme.breakpoints.up('sm')] = {
                display: 'inline',
            },
            _a),
    });
});
export var StepLabel = function (_a) {
    var children = _a.children, _b = _a.StepIconComponent, StepIconComponent = _b === void 0 ? StepIcon : _b, props = __rest(_a, ["children", "StepIconComponent"]);
    var classes = useStyles();
    return (React.createElement(MaterialStepLabel, __assign({ classes: classes, StepIconComponent: StepIconComponent }, props), children));
};
//# sourceMappingURL=StepLabel.js.map